"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcToken = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _jwtDecode = require("jwt-decode");
/* eslint-disable @typescript-eslint/naming-convention -- Token properties don't follow our rules */

class OidcToken {
  constructor(token) {
    (0, _defineProperty2.default)(this, "token", void 0);
    (0, _defineProperty2.default)(this, "payload", void 0);
    (0, _defineProperty2.default)(this, "toString", () => this.token);
    (0, _defineProperty2.default)(this, "getClaim", claim => this.payload[claim]);
    if (typeof token === 'string') {
      this.token = token;
    } else {
      this.token = token.Token;
    }
    this.payload = (0, _jwtDecode.jwtDecode)(this.token);
  }
}
exports.OidcToken = OidcToken;
